import logo from '../assets/images/logo2.png'

const Logo2 = () => {
  return <img width="120" height="120" viewBox="0 0 120 120" src={logo} alt='sotcot' className='logo' />
}

export default Logo2
